__turbopack_context__.v({
  "className": "avertasemibold_8a3350ae-module__lc4t9a__className",
  "variable": "avertasemibold_8a3350ae-module__lc4t9a__variable",
});
